import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ffc49838"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "panel error"
}
const _hoisted_2 = {
  key: 0,
  class: "light-text"
}

import IconUI from '@/components/CommonUI/IconUI.vue'
import LoaderUI from '@/components/CommonUI/LoaderUI.vue'
import { useGettext } from 'vue3-gettext'


export default /*#__PURE__*/_defineComponent({
  __name: 'LoaderErrorBlock',
  props: {
  errorTitle: { type: String, default: '' },
  errorMessage: { type: String, default: '' },
},
  setup(__props) {



const { $gettext } = useGettext()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", null, [
            _createTextVNode(_toDisplayString(_unref($gettext)('Error')) + ": ", 1),
            (__props.errorTitle.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref($gettext)(__props.errorTitle)), 1))
              : _createCommentVNode("", true),
            _createVNode(IconUI, {
              name: "danger",
              fill: "white",
              class: "pull-right"
            })
          ]),
          _createElementVNode("p", null, _toDisplayString(__props.errorMessage), 1)
        ]))
      : (_openBlock(), _createBlock(LoaderUI, {
          key: 1,
          "ditto-plus": "",
          "data-testid": "app-loader"
        }))
  ]))
}
}

})